import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {DW_LG} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {InventorySku, InventorySkus, PracticeData} from "../types";

export class EditInventorySkuHelper {

  static addInventorySku() {
    const id = BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditInventorySkuFragment
        onInventorySkuSaved={sku => BaseApp.CONTEXT.hideDialog(id)}/>);
  }

  static editInventorySku(sku: InventorySku) {
    const id = BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditInventorySkuFragment
        onInventorySkuSaved={sku => BaseApp.CONTEXT.hideDialog(id)}
        edit={sku}/>);
  }
}

type EditInventorySkuFragmentProps = PageFragmentProps & {
  onInventorySkuSaved: (sku: InventorySku) => void,
  edit?: InventorySku,
}

class EditInventorySkuFragment extends DialogFragment<EditInventorySkuFragmentProps> {

  private readonly inventorySkus: InventorySkus;
  private readonly inventorySku: InventorySku;

  constructor(props: EditInventorySkuFragmentProps, context: any) {
    super(props, context);
    this.inventorySkus = PracticeData.provider().presets.inventorySkus;
    this.inventorySku = props.edit || InventorySku.createNew();
  }

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: !Boolean(this.props.edit) ? "Add SKU" : "Edit SKU",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return "Save";
  }

  onActionButtonClicked() {
    this.saveInventorySku().then(() => this.props.onInventorySkuSaved(this.inventorySku));
  }

  private async saveInventorySku() {
    await this.inventorySkus.addListItem(this.inventorySku);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: "84dvw", maxWidth: DW_LG}}>
      <FormGenContainer
        mode={!Boolean(this.props.edit) ? FormGenContainerMode.CREATE : FormGenContainerMode.EDIT}
        content={this.inventorySku}
        saveActionButtonProvider={this}
      />
    </Box>;
  }
}
